import { StorageAdapter, StorageCallback } from "../../storage/StorageAdapter";
import { buildNewsStoryAssetsPath, buildNewsStoryPath } from "../../storage";
import { BaseMarkdownStorageService, BaseStorageService } from "../StorageService";
import { StorageUploadFile } from "../../storage/common";
import { ILogger } from "../../utils/logger";

/** Takes care of all the media for newss */
export class StorageNewsService extends BaseMarkdownStorageService {
    constructor(
        protected storyId: string,
        storageAdapter: StorageAdapter,
        logger?: ILogger,
    ) {
        super(storageAdapter, logger)
    }

    protected getBasePath(): string {
        return buildNewsStoryPath(this.storyId);
    }

    /*
     * Custom method to upload a md file
     */
    async uploadMdForNews(
        contentMD: string,
        language_code?: string,
        callback?: StorageCallback
    ): Promise<{ path: string; url: string; size: number }> {
        return super.uploadMarkdown(
            contentMD,
            language_code,
            callback,
            {
                storyId: this.storyId,
            })
    }
}

export class StorageNewsAssetService extends BaseStorageService {
    constructor(
        protected storyId: string,
        storageAdapter: StorageAdapter,
        logger?: ILogger,
    ) {
        super(storageAdapter, logger)
    }

    protected getBasePath(): string {
        return buildNewsStoryAssetsPath(this.storyId)
    }

    // Customize file size limit (20MB for news media)
    protected getMaxFileSize(): number {
        return 20 * 1024 * 1024; // 20MB
    }

    // Only allow images and videos
    protected getAllowedMimeTypes(): string[] {
        return [
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/webp',
            'video/mp4',
            'video/quicktime',
        ];
    }

    /**
     * Custom method to upload an asset with news context
     */
    async uploadAssetForNews(
        buffer: StorageUploadFile,
        filename: string,
        callback?: StorageCallback
    ): Promise<{ path: string; url: string; size: number }> {
        const result = await this
            .upload(buffer, filename, callback, {
                storyId: this.storyId,
                originalFileName: filename,
            });

        return result;
    }

    /** List all the medias associated to this news story */
    listMedias() {
        return this.listFiles(buildNewsStoryAssetsPath(this.storyId))
    }

    /** Delete all the medias associated to this news story */
    deleteAllMedias() {
        return this.deleteDirectory(buildNewsStoryAssetsPath(this.storyId))
    }
}